import { render, staticRenderFns } from "./DeliveryUpdate.vue?vue&type=template&id=facbaca2&scoped=true&"
import script from "./DeliveryUpdate.vue?vue&type=script&lang=js&"
export * from "./DeliveryUpdate.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryUpdate.vue?vue&type=style&index=0&id=facbaca2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "facbaca2",
  null
  
)

export default component.exports